import { createContext } from 'react';

const ReactionsContext = createContext({});
export default ReactionsContext;
